export { default } from '@shikijs/langs/vue-html'
